import classNames from 'classnames';
import { useMemo } from 'react';
import { t } from 'ttag';

import { useFilterData } from '@hook/productFilters';
import { Select } from '@ui/Select';
import { MyClothesSortTypes } from '@constants';

import s from './SortSelect.sss';

const getOptions: () => OptionType[] = () => [
  {
    value: MyClothesSortTypes.BY_POPULAR,
    label: t`за популярністю`,
  },
  {
    value: MyClothesSortTypes.PRICE_ASC,
    label: t`від дешевих до дорогих`,
  },
  {
    value: MyClothesSortTypes.PRICE_DESC,
    label: t`від дорогих до дешевих`,
  },
  {
    value: MyClothesSortTypes.DATE_DESC,
    label: t`за датою додавання`,
  },
];

type SortSelectProps = {
  defaultSorting?: MyClothesSortTypes;
  className?: string;
};

type OptionType = {
  label: string,
  value: MyClothesSortTypes
};

export const SortSelect: React.FC<SortSelectProps> = ({
  defaultSorting = MyClothesSortTypes.BY_POPULAR,
  className,
}) => {
  const { filters, setFilter } = useFilterData();
  const options = useMemo(getOptions, []);
  const valueMapping = useMemo(
    () => (
      (Object.keys(options) as unknown as number[])
        .reduce(
          (result, key) => {
            const option = options[key];

             
            result[`${option.value}`] = options[key];
            return result;
          },
          {} as Record<MyClothesSortTypes, OptionType>,
        )
    ),
    [options],
  );

  return (
    (
      <div className={classNames(s.root, className)}>
        <span className={s.text}>{t`Сортувати:`}</span>
        <Select
          className={s.select}
          options={options}
          name="sorted"
          onChange={({ value }: OptionType) => setFilter({ orderBy: value })}
          value={filters.orderBy ? valueMapping[filters.orderBy] : valueMapping[defaultSorting]}
          placeholder={t`Виберіть сортування`}
          isSearchable={false}
        />
      </div>
    )
  );
};
